// @ts-strict-ignore
import { memo } from 'react'
import { CardContent, Card, Divider, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import PageHeader from 'components/PageHeader'
import PageContainer from 'components/PageContainer'
import Picture from 'components/Picture'
import FormSubmitButton from 'components/FormSubmitButton'
import TextField from 'components/TextField'
import { Email } from '@mui/icons-material'
import useForgotPasswordForm from 'components/ForgotPassword/useForgotPasswordForm'
import { PreloadedQuery, readInlineData, usePreloadedQuery } from 'react-relay'
import { graphql } from 'relay-runtime'
import { isGuest } from 'services/user'
import { ForgotPassword_Query } from '__generated__/ForgotPassword_Query.graphql'
import AuthGate from 'components/AuthGate'
import { ForgotPassword_isAllowed$key } from '__generated__/ForgotPassword_isAllowed.graphql'
import { FormProvider } from 'react-hook-form'
import useStyles from './styles'

export function isAllowed(userFragmentRef: ForgotPassword_isAllowed$key) {
  const user = readInlineData(graphql`
    fragment ForgotPassword_isAllowed on User @inline {
      ...user_isGuest
    }
  `, userFragmentRef)

  return isGuest(user)
}

export const ForgotPasswordQuery = graphql`
    query ForgotPassword_Query {
      currentUser {
        ...AuthGate_User
        ...auth_checkAuthForPage
        ...ForgotPassword_isAllowed
      }
    }
`

const ForgotPassword = ({ preloadedQuery }: { preloadedQuery: PreloadedQuery<ForgotPassword_Query>}) => {
  const { classes } = useStyles()
  const theme = useTheme()
  const data = usePreloadedQuery(ForgotPasswordQuery, preloadedQuery)
  const form = useForgotPasswordForm()
  const { useFormField, submit } = form
  return (
    <AuthGate
      userFragmentRef={data?.currentUser}
      allowed={isAllowed(data?.currentUser)}
    >
      <div>
        <PageHeader compact />

        <PageContainer>
          <div className={classes.loginContainer}>
            <div className={classes.login}>
              <Card raised>
                <FormProvider {...form}>
                  <form onSubmit={submit}>
                    <CardContent className={classes.box}>
                      <Picture
                        className={classes.logo}
                        src="https://flexhire-images.s3.amazonaws.com/images/logos/flexhire-logo-blue.png"
                        srcFallback="https://flexhire-images.s3.amazonaws.com/images/logos/flexhire-logo-blue.png"
                        alt="Flexhire"
                      />

                      <Typography variant="body1" className={classes.copy}>
                        Enter your Email to reset your Password
                      </Typography>
                    </CardContent>
                    <Divider style={{ margin: theme.spacing(4, 0) }} />

                    <CardContent className={classes.box}>
                      <TextField
                        name="email"
                        label="Email"
                        {...useFormField('email', 'typing')}
                        type="email"
                        fullWidth
                      />
                    </CardContent>

                    <CardContent className={classes.box}>
                      <div className={classes.loginButton}>
                        <FormSubmitButton
                          onClick={submit}
                          dataCy="submit"
                          icon={<Email />}
                          label="Send Instructions"
                        />
                      </div>
                    </CardContent>
                  </form>
                </FormProvider>
              </Card>
            </div>
          </div>
        </PageContainer>
      </div>
    </AuthGate>
  )
}

export default memo(ForgotPassword)
